<template>
  <div class="fund-record-page page">
    <van-nav-bar :title="$t('my.fund_record') || 'Fund Record'" class="custom-nav" :border="false">
      <template #left>
        <van-icon name="arrow-left" color="#e6b98a" size="24" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main-content">
      <van-tabs v-model="activeTab" background="#2b2b2b" color="#e6b98a" title-active-color="#e6b98a" title-inactive-color="#999" @change="onTabChange">
        
        <!-- 充值记录 -->
        <van-tab :title="$t('my.recharge_record') || 'Recharge Record'" name="recharge">
          <van-pull-refresh v-model="isLoadingRecharge" @refresh="onRefreshRecharge">
            <van-empty v-if="rechargeList.length === 0" :description="$t('withdraw.empty_data') || 'No Data'" />
            <div v-else class="record-list">
              <div class="record-item" v-for="(item, index) in rechargeList" :key="index">
                <div class="item-header">
                  <span class="title">
                    <van-icon name="gold-coin-o" class="icon gold" />
                    {{ $t('recharge.recharge') || 'Recharge' }}
                  </span>
                  <span class="status" :class="getStatusClass(item.status)">
                    {{ item.status === 1 ? ($t('my.audit_waiting') || 'Pending Audit') : item.status === 2 ? ($t('my.audit_success') || 'Audit Successful') : item.status === 3 ? ($t('my.audit_reject') || 'Audit Rejected') : item.status_text }}
                  </span>
                </div>
                <div class="item-body">
                  <div class="info-row">
                    <span class="label">{{ $t('reservation.money') || 'Amount' }}:</span>
                    <span class="value amount">+{{ $money(item.money) }}</span>
                  </div>
                  <div class="info-row">
                    <span class="label">{{ $t('reservation.order_time') || 'Time' }}:</span>
                    <span class="value">{{ item.create_time }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>

        <!-- 提现记录 -->
        <van-tab :title="$t('my.withdraw_record') || 'Withdraw Record'" name="withdraw">
          <van-pull-refresh v-model="isLoadingWithdraw" @refresh="onRefreshWithdraw">
            <van-empty v-if="withdrawList.length === 0" :description="$t('withdraw.empty_data') || 'No Data'" />
            <div v-else class="record-list">
              <div class="record-item" v-for="(item, index) in withdrawList" :key="index">
                <div class="item-header">
                  <span class="title">
                    <van-icon name="balance-pay" class="icon silver" />
                    {{ $t('my.withdraw') || 'Withdraw' }}
                  </span>
                  <span class="status" :class="getStatusClass(item.status)">
                    {{ item.status === 1 ? ($t('my.audit_waiting') || 'Pending Audit') : item.status === 2 ? ($t('my.audit_success') || 'Audit Successful') : item.status === 3 ? ($t('my.audit_reject') || 'Audit Rejected') : item.status_text }}
                  </span>
                </div>
                <div class="item-body">
                  <div class="info-row">
                    <span class="label">{{ $t('reservation.money') || 'Amount' }}:</span>
                    <span class="value amount negative">-{{ $money(item.money) }}</span>
                  </div>
                  <div class="info-row">
                    <span class="label">{{ $t('reservation.order_time') || 'Time' }}:</span>
                    <span class="value">{{ item.create_time }}</span>
                  </div>
                  <div class="info-row" v-if="item.status === 3 && item.remark">
                    <span class="label">{{ $t('withdraw.reject_reason') || 'Reason' }}:</span>
                    <span class="value" style="color: #ff4d4f;">{{ item.remark }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>

      </van-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FundRecord',
  data() {
    return {
      activeTab: 'recharge',
      isLoadingRecharge: false,
      isLoadingWithdraw: false,
      rechargeList: [],
      withdrawList: []
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    onTabChange(name) {
      if (name === 'recharge' && this.rechargeList.length === 0) {
        this.getRechargeList();
      } else if (name === 'withdraw' && this.withdrawList.length === 0) {
        this.getWithdrawList();
      }
    },
    onRefreshRecharge() {
      setTimeout(() => {
        this.getRechargeList();
      }, 500);
    },
    onRefreshWithdraw() {
      setTimeout(() => {
        this.getWithdrawList();
      }, 500);
    },
    getRechargeList() {
      this.isLoadingRecharge = true;
      this.$http({
        method: 'get',
        url: 'user_get_recharge_list'
      }).then(res => {
        this.isLoadingRecharge = false;
        if (res.code === 200) {
          this.rechargeList = res.data || [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).catch(() => {
        this.isLoadingRecharge = false;
      });
    },
    getWithdrawList() {
      this.isLoadingWithdraw = true;
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_list'
      }).then(res => {
        this.isLoadingWithdraw = false;
        if (res.code === 200) {
          this.withdrawList = res.data || [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      }).catch(() => {
        this.isLoadingWithdraw = false;
      });
    },
    getStatusClass(status) {
      // 1: 待审核(pending), 2: 审核成功(success), 3: 审核退回(reject)
      if (status === 1) return 'status-pending';
      if (status === 2) return 'status-success';
      if (status === 3) return 'status-reject';
      return '';
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getRechargeList();
    }
  }
};
</script>

<style lang="less" scoped>
.fund-record-page {
  background-color: #1f1c1f;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 导航栏暗金风格 */
.custom-nav {
  background-color: #2b2b2b !important;
  border-bottom: 2px solid #766350;
}
::v-deep .custom-nav .van-nav-bar__title {
  color: #e6b98a !important;
  font-size: 36px;
}
::v-deep .van-hairline--bottom::after {
  border-bottom-width: 0 !important;
}

.main-content {
  flex: 1;
  overflow-y: auto;
}

::v-deep .van-tabs__nav {
  border-bottom: 1px solid #3a3a3a;
}
::v-deep .van-tab {
  font-size: 30px;
}
::v-deep .van-tabs__line {
  background-color: #e6b98a;
}

.record-list {
  padding: 20px;
}

.record-item {
  background: #2b2b2b;
  border: 1px solid #3a3a3a;
  border-radius: 16px;
  margin-bottom: 20px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed #444;
  padding-bottom: 16px;
  margin-bottom: 16px;
  
  .title {
    color: #fff;
    font-size: 32px;
    font-weight: bold;
    display: flex;
    align-items: center;
    
    .icon {
      font-size: 40px;
      margin-right: 12px;
      
      &.gold {
        color: #f3c7a2;
      }
      &.silver {
        color: #a8b0c3;
      }
    }
  }
  
  .status {
    font-size: 26px;
    padding: 6px 16px;
    border-radius: 20px;
    
    &.status-pending {
      background: rgba(230, 185, 138, 0.1);
      color: #e6b98a;
    }
    &.status-success {
      background: rgba(7, 193, 96, 0.1);
      color: #07c160;
    }
    &.status-reject {
      background: rgba(255, 77, 79, 0.1);
      color: #ff4d4f;
    }
  }
}

.item-body {
  .info-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    font-size: 28px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .label {
      color: #999;
    }
    
    .value {
      color: #ccc;
      
      &.amount {
        font-size: 36px;
        font-weight: bold;
        color: #07c160; /* Recharge is green */
        
        &.negative {
          color: #ff4d4f; /* Withdraw is red */
        }
      }
    }
  }
}
</style>
